export const homepageDescription =
  "Shop professional clippers, trimmers, shavers, blades, styling products, sanitation essentials, and barber accessories from EGT Supplies.";

export const getHomepageDescription = (
  shop?: { description?: string | null } | null
): string => {
  const description = shop && shop.description ? shop.description.trim() : "";
  return description || homepageDescription;
};
